var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouteWithChildren',{attrs:{"parent-level":2}},[_c('DashboardsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }